<template>
  <div class="ask-que">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-12">
          <h2 class="text-center my-4 hk-heading">
            Curious to Know More? These Questions Might Help!
          </h2>
        </div>
      </div>
    </div>
    <div class="container mt-6">
      <div class="row">
        <!-- Left Column -->
        <div class="col-md-7 mb-4">
          <div class="accordion" id="accordionExample">
            <div
              v-for="(faq, index) in faqs"
              :key="index"
              class="accordion-item"
            >
              <h2 class="hk-body accordion-header" :id="'heading' + index">
                <button
                  class="accordion-button custom-toggle d-flex justify-content-between align-items-center"
                  :class="{ collapsed: activeIndex !== index }"
                  type="button"
                  :data-bs-toggle="'collapse'"
                  :data-bs-target="'#collapse' + index"
                  :aria-expanded="activeIndex === index ? 'true' : 'false'"
                  :aria-controls="'collapse' + index"
                  @click="setActive(index)"
                >
                  {{ $t(faq.questionKey) }}
                  <img
                    src="@/assets/home/arrow-down-16.svg"
                    alt="toggle icon"
                    class="ms-auto toggle-icon"
                    :class="{ 'rotate': activeIndex === index }"
                  />
                </button>
              </h2>
              <div
                :id="'collapse' + index"
                class="accordion-collapse collapse"
                :class="{ show: activeIndex === index }"
                :aria-labelledby="'heading' + index"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body p-0">
                  <p class="according-inside hk-subbody">
                    {{ $t(faq.answerKey) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Column -->
        <div class="col-md-5">
          <div v-for="(card, index) in infoCards" :key="index" class="info-box">
            <h3 class="hk-miniheading">{{ $t(card.headingKey) }}</h3>
            <p class="hk-micro-text">{{ $t(card.subheadingKey) }}</p>
            <a :href="card.link" class="know-more">{{ $t(card.linkTextKey) }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: 0,
      faqs: [
        { questionKey: "landing_page_faq.faq_one_que", answerKey: "landing_page_faq.faq_one_ans" },
        { questionKey: "landing_page_faq.faq_two_que", answerKey: "landing_page_faq.faq_two_ans" },
        { questionKey: "landing_page_faq.faq_three_que", answerKey: "landing_page_faq.faq_three_ans" },
        { questionKey: "landing_page_faq.faq_four_que", answerKey: "landing_page_faq.faq_four_ans" },
        { questionKey: "landing_page_faq.faq_five_que", answerKey: "landing_page_faq.faq_five_ans" },
        { questionKey: "landing_page_faq.faq_six_que", answerKey: "landing_page_faq.faq_six_ans" },
        { questionKey: "landing_page_faq.faq_seven_que", answerKey: "landing_page_faq.faq_seven_ans" },
        { questionKey: "landing_page_faq.faq_eight_que", answerKey: "landing_page_faq.faq_eight_ans" },
        { questionKey: "landing_page_faq.faq_nine_que", answerKey: "landing_page_faq.faq_nine_ans" },
        { questionKey: "landing_page_faq.faq_ten_que", answerKey: "landing_page_faq.faq_ten_ans" }
      ],
      infoCards: [
        {
          headingKey: "landing_page_faq.faq_card_one_heading",
          subheadingKey: "Don’t let glitches disrupt a great guest experience. HotelKey offers 24/7 customer support to provide expert help anytime, anywhere.",
          linkTextKey: "landing_page_faq.contact_support",
          link: "/support"
        },
        {
          headingKey: "landing_page_faq.faq_card_two_heading",
          subheadingKey: "Be confident in selecting a PMS trusted by hoteliers worldwide. Our high customer satisfaction scores are a testament to the positive impact HotelKey PMS can have on hotel operations.",
          link: "/testimonials",
          linkTextKey: "landing_page_faq.check_out"
        }
      ]
    };
  },
  methods: {
    setActive(index) {
      this.activeIndex = this.activeIndex === index ? -1 : index;
    }
  }
};
</script>

<style scoped>
.accordion-button::after {
  display: none !important; /* Remove default Bootstrap arrow */
}

.hk-subbody {
  color: #5c5c5c;
  font-size: 14px;
  font-weight: 300;
  font-family: inter;
  line-height: 24px;
  padding: 0px 20px 0px 20px;
}

.accordion-button {
  z-index: 3;
  border-color: unset;
  outline: unset;
  box-shadow: unset;
  padding: 20px;
  color: #000;
  font-size: 16px;
  font-weight: 400;
  font-family: inter;
  line-height: 24px;
}

.accordion-button:not(.collapsed) {
  color: #000;
  background-color: unset;
  box-shadow: unset;
}

.info-box {
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 20px;
}

.toggle-icon {
  width: 16px;
  height: 16px;
  transition: transform 0.3s ease;
}

.toggle-icon.rotate {
  transform: rotate(180deg);
}
</style>
